(function () {
    const section = document.querySelector('[data-search-section]');
    if (!section) return;

    const nodes = {
        filters: section.querySelector('[data-filters]'),
        overlay: section.querySelector('[data-filter-overlay]'),
        sortSelect: section.querySelector('[data-sort-select]'),
        searchInput: section.querySelector('[data-search-input]'),
        searchForm: section.querySelector('[data-search-form]'),
        results: section.querySelector('[data-search-results]'),
        status: section.querySelector('[data-search-count]'),
        actions: section.querySelector('[data-search-actions]'),
        filtersInner: section.querySelector('[data-search-filters-inner]'),
        loading: section.querySelector('[data-search-loading]'),
        predictive: section.querySelector('[data-predictive]'),
        predictiveSuggestions: section.querySelector('[data-predictive-suggestions]'),
        predictiveProducts: section.querySelector('[data-predictive-products]'),
        predictiveFooter: section.querySelector('[data-predictive-footer]'),
        predictiveLoading: section.querySelector('[data-predictive-loading]'),
        clearBtn: section.querySelector('[data-search-clear]'),
    };

    const baseUrl = section.getAttribute('data-search-url') || window.location.pathname;
    const sectionId = section.getAttribute('data-section-id') || 'main-search';
    const suggestionLimit = Number(section.getAttribute('data-suggestion-limit')) || 6;
    const productLimit = Number(section.getAttribute('data-predictive-products-limit')) || 4;
    const moneyFormat = section.getAttribute('data-money-format') || '${{amount}}';

    const setLoading = (isLoading) => {
        section.classList.toggle('is-loading', isLoading);
        section.setAttribute('aria-busy', isLoading ? 'true' : 'false');
        if (nodes.loading) {
            nodes.loading.setAttribute('aria-hidden', isLoading ? 'false' : 'true');
        }
    };

    let boundSearchForm = null;
    let predictiveInstance = null;

    const refreshNodes = () => {
        nodes.filters = section.querySelector('[data-filters]');
        nodes.overlay = section.querySelector('[data-filter-overlay]');
        nodes.sortSelect = section.querySelector('[data-sort-select]');
        nodes.searchInput = section.querySelector('[data-search-input]');
        nodes.searchForm = section.querySelector('[data-search-form]');
        nodes.results = section.querySelector('[data-search-results]');
        nodes.status = section.querySelector('[data-search-count]');
        nodes.actions = section.querySelector('[data-search-actions]');
        nodes.filtersInner = section.querySelector('[data-search-filters-inner]');
        nodes.loading = section.querySelector('[data-search-loading]');
        nodes.predictive = section.querySelector('[data-predictive]');
        nodes.predictiveSuggestions = section.querySelector('[data-predictive-suggestions]');
        nodes.predictiveProducts = section.querySelector('[data-predictive-products]');
        nodes.predictiveFooter = section.querySelector('[data-predictive-footer]');
        nodes.predictiveLoading = section.querySelector('[data-predictive-loading]');
        nodes.clearBtn = section.querySelector('[data-search-clear]');
    };

    const bindSearchForm = () => {
        if (!nodes.searchForm || nodes.searchForm === boundSearchForm) return;
        nodes.searchForm.addEventListener('submit', (event) => {
            event.preventDefault();
            applyFilters();
            if (predictiveInstance) {
                predictiveInstance.hide();
            }
        });
        boundSearchForm = nodes.searchForm;
    };

    const initPredictive = () => {
        const predictiveSearch = window.EEGPredictiveSearch;
        if (!predictiveSearch || typeof predictiveSearch.create !== 'function') return;
        if (!nodes.searchInput || !nodes.predictive || !nodes.predictiveSuggestions || !nodes.predictiveProducts) return;

        if (predictiveInstance && typeof predictiveInstance.destroy === 'function') {
            predictiveInstance.destroy();
        }

        const renderSuggestion = (term) => {
            if (!term) return null;
            const listItem = document.createElement('li');
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'eeg-search__predictive-suggestion';
            button.textContent = term;
            button.setAttribute('data-predictive-term', term);
            listItem.appendChild(button);
            return listItem;
        };

        const renderProduct = (product, helpers) => {
            if (!product) return null;
            const listItem = document.createElement('li');
            const link = document.createElement('a');
            link.className = 'eeg-search__predictive-product';
            link.href = product.url || '#';

            const imageWrapper = document.createElement('div');
            imageWrapper.className = 'eeg-search__predictive-image';
            const imageData = helpers.getProductImage(product);
            if (imageData && imageData.url) {
                const image = document.createElement('img');
                image.src = helpers.buildSizedImageUrl(imageData.url, 128);
                image.alt = imageData.alt || product.title || '';
                image.loading = 'lazy';
                image.decoding = 'async';
                image.width = 64;
                image.height = 80;
                imageWrapper.appendChild(image);
            }

            const meta = document.createElement('div');
            meta.className = 'eeg-search__predictive-meta';
            const title = document.createElement('div');
            title.className = 'eeg-search__predictive-title';
            title.textContent = product.title || '';
            meta.appendChild(title);

            const rawPrice = product.price || product.price_min || product.price_max || '';
            const priceValue = helpers.formatMoney(rawPrice);
            if (priceValue) {
                const price = document.createElement('div');
                price.className = 'eeg-search__predictive-price';
                price.textContent = priceValue;
                meta.appendChild(price);
            }

            link.appendChild(imageWrapper);
            link.appendChild(meta);
            listItem.appendChild(link);
            return listItem;
        };

        predictiveInstance = predictiveSearch.create({
            input: nodes.searchInput,
            panel: nodes.predictive,
            suggestionsList: nodes.predictiveSuggestions,
            productsList: nodes.predictiveProducts,
            footer: nodes.predictiveFooter,
            loading: nodes.predictiveLoading,
            clearButton: nodes.clearBtn,
            container: section,
            containerVisibleClass: 'has-predictive-open',
            suggestionLimit,
            productLimit,
            moneyFormat,
            getFooterData: (queryValue) => {
                const safeQuery = queryValue || '';
                const href = safeQuery
                    ? `${baseUrl}?q=${encodeURIComponent(safeQuery)}&type=product`
                    : `${baseUrl}?type=product`;
                return {
                    href,
                    text: safeQuery ? `View all results for "${safeQuery}"` : 'View all results',
                };
            },
            renderSuggestion,
            renderProduct,
            onSubmit: (queryValue) => {
                if (!nodes.searchInput) return;
                nodes.searchInput.value = queryValue;
                applyFilters();
            },
        });

        if (predictiveInstance && nodes.searchInput) {
            const initialQuery = nodes.searchInput.value.trim();
            if (document.activeElement === nodes.searchInput && initialQuery.length >= 2) {
                predictiveInstance.refresh();
            }
        }
    };

    const getScrollAnchor = () => section.querySelector('.eeg-search__hero') || nodes.results || section;

    const openFilters = () => {
        if (!nodes.filters) return;
        nodes.filters.classList.add('is-open');
        nodes.filters.setAttribute('aria-hidden', 'false');
        if (nodes.overlay) nodes.overlay.classList.add('is-open');
        document.body.classList.add('overlay-open');
    };

    const closeFilters = () => {
        if (nodes.filters) {
            nodes.filters.classList.remove('is-open');
            nodes.filters.setAttribute('aria-hidden', 'true');
        }
        if (nodes.overlay) nodes.overlay.classList.remove('is-open');
        document.body.classList.remove('overlay-open');
    };

    const buildFiltersUrl = () => {
        const params = new URLSearchParams();
        const queryValue = nodes.searchInput ? nodes.searchInput.value.trim() : '';
        if (queryValue) {
            params.set('q', queryValue);
        }
        params.set('type', 'product');

        if (nodes.sortSelect && nodes.sortSelect.value) {
            params.set('sort_by', nodes.sortSelect.value);
        }

        if (nodes.filters) {
            const checkboxes = nodes.filters.querySelectorAll('input[type="checkbox"]:checked:not([data-price-range])');
            checkboxes.forEach((checkbox) => {
                if (checkbox.name && checkbox.value) {
                    params.append(checkbox.name, checkbox.value);
                }
            });

            const priceChoice = nodes.filters.querySelector('[data-price-range]:checked');
            if (priceChoice) {
                const minParam = priceChoice.getAttribute('data-min-param');
                const maxParam = priceChoice.getAttribute('data-max-param');
                const minValue = priceChoice.getAttribute('data-min-value');
                const maxValue = priceChoice.getAttribute('data-max-value');

                if (minParam && minValue !== null && minValue !== '') {
                    params.set(minParam, minValue);
                }

                if (maxParam && maxValue !== null && maxValue !== '') {
                    params.set(maxParam, maxValue);
                }
            }
        }

        const queryString = params.toString();
        if (queryString) {
            return `${baseUrl}?${queryString}`;
        }
        return baseUrl;
    };

    const normalizePriceValue = (value) => {
        if (value === null || value === '') return null;
        const numberValue = Number(value);
        if (Number.isNaN(numberValue)) return null;
        if (numberValue === 0) return null;
        return numberValue;
    };

    const syncPriceSelectionFromUrl = () => {
        const priceRanges = section.querySelectorAll('[data-price-range]');
        if (!priceRanges.length) return;
        const minParam = priceRanges[0].getAttribute('data-min-param');
        const maxParam = priceRanges[0].getAttribute('data-max-param');
        if (!minParam && !maxParam) return;
        const url = new URL(window.location.href);
        const minValue = normalizePriceValue(minParam ? url.searchParams.get(minParam) : null);
        const maxValue = normalizePriceValue(maxParam ? url.searchParams.get(maxParam) : null);

        let matched = false;
        priceRanges.forEach((range) => {
            const rangeMin = normalizePriceValue(range.getAttribute('data-min-value'));
            const rangeMax = normalizePriceValue(range.getAttribute('data-max-value'));
            const isMatch = rangeMin === minValue && rangeMax === maxValue;
            range.checked = isMatch;
            if (isMatch) matched = true;
        });

        if (!matched && minValue === null && maxValue === null) {
            priceRanges.forEach((range) => {
                range.checked = false;
            });
        }
    };

    const updateSection = (newSection) => {
        const stateAttributes = [
            'data-search-has-query',
            'data-search-has-results',
            'data-search-has-filters',
        ];
        stateAttributes.forEach((attr) => {
            if (newSection.hasAttribute(attr)) {
                section.setAttribute(attr, newSection.getAttribute(attr));
            } else {
                section.removeAttribute(attr);
            }
        });

        const newResults = newSection.querySelector('[data-search-results]');
        if (nodes.results && newResults) {
            nodes.results.innerHTML = newResults.innerHTML;
        }

        const newStatus = newSection.querySelector('[data-search-count]');
        if (nodes.status && newStatus) {
            nodes.status.innerHTML = newStatus.innerHTML;
        }

        const newFiltersInner = newSection.querySelector('[data-search-filters-inner]');
        if (nodes.filtersInner && newFiltersInner) {
            nodes.filtersInner.innerHTML = newFiltersInner.innerHTML;
        }

        const newActions = newSection.querySelector('[data-search-actions]');
        if (nodes.actions && newActions) {
            nodes.actions.innerHTML = newActions.innerHTML;
        }

        const newSortSelect = newSection.querySelector('[data-sort-select]');
        const newSearchInput = newSection.querySelector('[data-search-input]');
        refreshNodes();

        if (nodes.sortSelect && newSortSelect) {
            nodes.sortSelect.value = newSortSelect.value;
            const defaultSort = newSortSelect.getAttribute('data-default-sort');
            if (defaultSort) {
                nodes.sortSelect.setAttribute('data-default-sort', defaultSort);
            }
        }

        if (nodes.searchInput && newSearchInput) {
            nodes.searchInput.value = newSearchInput.value;
        }

        if (nodes.searchForm) {
            const sortInput = nodes.searchForm.querySelector('input[name="sort_by"]');
            if (sortInput && nodes.sortSelect) {
                sortInput.value = nodes.sortSelect.value;
            }
        }

        bindSearchForm();
        initPredictive();
    };

    const filterController = window.EEGFilterResultsController
        ? window.EEGFilterResultsController.create({
            section,
            sectionId,
            sectionSelector: '[data-search-section]',
            historyStateKey: 'searchUrl',
            cacheLimit: 12,
            storageKey: 'eegSearchCache',
            buildFiltersUrl,
            updateSection,
            setLoading,
            getScrollAnchor,
            closeFilters,
            onAfterUpdate: syncPriceSelectionFromUrl,
        })
        : null;

    const applyFilters = (options = {}) => {
        if (!filterController) {
            window.location.href = buildFiltersUrl();
            return;
        }
        filterController.applyFilters(options);
    };

    const fetchAndRender = (targetUrl, options = {}) => {
        if (!filterController) {
            window.location.href = targetUrl;
            return;
        }
        filterController.fetchAndRender(targetUrl, options);
    };

    const canAutoApply = window.EEGFilterResultsController
        ? window.EEGFilterResultsController.shouldAutoApply
        : () => window.matchMedia('(min-width: 990px)').matches;

    const handleCustomClick = (event, target) => {
        const suggestionTag = target.closest('[data-suggestion]');
        if (suggestionTag && nodes.searchInput) {
            event.preventDefault();
            const term = suggestionTag.getAttribute('data-suggestion') || '';
            nodes.searchInput.value = term;
            applyFilters();
            if (predictiveInstance) {
                predictiveInstance.hide();
            }
            return true;
        }

        const predictiveFooter = target.closest('[data-predictive-footer]');
        if (predictiveFooter) {
            event.preventDefault();
            applyFilters();
            if (predictiveInstance) {
                predictiveInstance.hide();
            }
            return true;
        }

        return false;
    };

    if (window.EEGFilterResultsController && typeof window.EEGFilterResultsController.bindFilterUI === 'function') {
        window.EEGFilterResultsController.bindFilterUI({
            section,
            openFilters,
            closeFilters,
            applyFilters,
            fetchAndRender,
            shouldAutoApply: canAutoApply,
            handleCustomClick,
        });
    }

    refreshNodes();
    bindSearchForm();
    initPredictive();
    syncPriceSelectionFromUrl();

    window.addEventListener('popstate', () => {
        fetchAndRender(window.location.href, { pushState: false, scroll: false });
    });
})();
